import { FallbackRender } from '@sentry/react'
import { useState } from 'react'
import { Heading } from 'react-aria-components'
import Dashboard from '~/components/Dashboard'
import { FeedbackDialogProvider } from '~/components/ErrorBoundary/components/FeedbackDialogProvider'
import { FeedbackForm } from '~/components/ErrorBoundary/components/FeedbackForm'
import { Button } from '~/ui/Button'
import { Modal } from '~/ui/Modal'

export const Fallback = ({ eventId }: Parameters<FallbackRender>[0]) => {
  const [showFeedbackForm, setShowFeedbackForm] = useState(false)
  return (
    <>
      <Dashboard noAction />
      <Modal isOpen isDismissable={false}>
        <FeedbackDialogProvider>
          {showFeedbackForm ? (
            <FeedbackForm errorEventId={eventId} onFeedbackComplete={() => window.location.reload()} />
          ) : (
            <>
              <Heading slot="title" className="text-lg font-bold pb-3">
                Uh oh!
              </Heading>
              <div className="flex flex-col gap-3">
                <div>SpecLab has encountered an error and needs to be reloaded.</div>
                <div>
                  The SpecLab team has been informed of this issue and will be working on a fix. To expedite the
                  process, you can describe what led to the error by clicking Share Feedback.
                </div>
                <div className="flex flex-row gap-3 pt-3">
                  <Button className="flex-grow" onClick={() => window.location.reload()}>
                    Reload App
                  </Button>
                  <Button variant="secondary" className="flex-grow" onClick={() => setShowFeedbackForm(true)}>
                    Share Feedback
                  </Button>
                </div>
              </div>
            </>
          )}
        </FeedbackDialogProvider>
      </Modal>
    </>
  )
}
